import req from "../../../services/psikotest/request";

class MbtiQuestionary {
  async list() {
    try {
      const res = await req.get("/api/psikotest_system/mbti_questionary/");
      return res;
    } catch (error) {
      return Promise.reject(error);
    }
  }
  async create(data: TPSMbtiQuestionary) {
    try {
      const res = await req.post("/api/psikotest_system/mbti_questionary/", data);
      return res;
    } catch (error) {
      return Promise.reject(error);
    }
  }
  async update(id: number, data: TPSMbtiQuestionary) {
    try {
      const res = await req.put("/api/psikotest_system/mbti_questionary/" + id, data);
      return res;
    } catch (error) {
      return Promise.reject(error);
    }
  }
  async delete(id: number) {
    try {
      const res = await req.delete("/api/psikotest_system/mbti_questionary/" + id);
      return res;
    } catch (error) {
      return Promise.reject(error);
    }
  }
}

export default MbtiQuestionary;
